var _defs, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _line, _path28, _circle, _line2, _path29, _circle2, _rect, _path30, _circle3, _line3, _rect2, _line4, _path31, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIvm3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 418.96 452.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d5ddeb;}.cls-2{fill:#812990;}.cls-3{fill:#fff;}.cls-4,.cls-5{fill:none;stroke:#6b7b84;stroke-miterlimit:10;stroke-width:0.5px;}.cls-5{stroke-dasharray:2 2;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "418.71 88.89 50.2 88.89 50.2 346.85 263.93 346.85 418.71 88.89"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "197.6 346.85 308.15 162.59 418.71 346.85 197.6 346.85"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "197.6 402.12 234.45 346.85 50.2 346.85 50.2 402.12 197.6 402.12"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.36,361.12h-.78v2.18h-.45v-2.18h-.77v-.45h2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.18,360.67v2.63h-.45v-1.87l-.87,1.35-.87-1.35v1.87h-.45v-2.63h.5l.82,1.27.83-1.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107,367.49v.85a6,6,0,0,0-1.49-.8,5.34,5.34,0,0,0-1.94-.32,5.85,5.85,0,0,0-2.27.43,5.58,5.58,0,0,0,0,10.3,5.85,5.85,0,0,0,2.27.43h.22a6,6,0,0,0,2.29-.43v-3h0a3.18,3.18,0,0,1-1,.67,3.39,3.39,0,0,1-1.23.22,4.55,4.55,0,0,1-.52,0h0a4.74,4.74,0,0,1-.72-.18,3,3,0,0,1-1-5,3.25,3.25,0,0,1,1-.66,3.49,3.49,0,0,1,1.24-.23,3.22,3.22,0,0,1,2.28.89,2.87,2.87,0,0,1,.93,2.16v5.57h2.68V367.49Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.66,378.38l-5.93-5.72v5.72H87.05V363.3h2.68V369l5.93-5.68h3.8l-7.83,7.51,7.83,7.55Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.63,367.22a4.94,4.94,0,0,1,2,.39,4.48,4.48,0,0,1,1.52,1.08,4.79,4.79,0,0,1,1,1.6,5.48,5.48,0,0,1,.34,1.95v6.14h-2.68v-6.14a2.26,2.26,0,0,0-.78-1.76,2.54,2.54,0,0,0-1.82-.72,2.61,2.61,0,0,0-1.86.72,2.36,2.36,0,0,0-.76,1.76v6.14H110.9V367.51h2.67v.81a5.47,5.47,0,0,1,1.37-.8A4.54,4.54,0,0,1,116.63,367.22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.91,367.51a4.85,4.85,0,0,1,1.8-.31v2.54a3.22,3.22,0,0,0-2.28.89,3,3,0,0,0-.93,2.16v5.59h-2.68V367.49h2.68v.83A5.71,5.71,0,0,1,152.91,367.51Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.76,367.22a6,6,0,0,1,2.3.43,5.93,5.93,0,0,1,1.88,1.2,5.76,5.76,0,0,1,1.26,1.78,5.46,5.46,0,0,1,0,4.34,5.76,5.76,0,0,1-1.26,1.78,5.93,5.93,0,0,1-1.88,1.2,6.34,6.34,0,0,1-4.59,0,5.93,5.93,0,0,1-1.88-1.2,5.76,5.76,0,0,1-1.26-1.78,5.46,5.46,0,0,1,0-4.34,5.76,5.76,0,0,1,1.26-1.78,5.93,5.93,0,0,1,1.88-1.2A6,6,0,0,1,160.76,367.22Zm0,2.54a3.18,3.18,0,0,0-2.27.89,3,3,0,0,0,1,5,3.39,3.39,0,0,0,1.23.22,3.36,3.36,0,0,0,1.23-.22,3.08,3.08,0,0,0,1-.67,2.93,2.93,0,0,0,0-4.3A3.31,3.31,0,0,0,160.76,369.76Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.29,367.22a6.07,6.07,0,0,1,2.3.43,6,6,0,0,1,1.87,1.2,5.45,5.45,0,0,1,1.26,1.78,5.35,5.35,0,0,1,0,4.34,5.45,5.45,0,0,1-1.26,1.78,6,6,0,0,1-1.87,1.2,6.37,6.37,0,0,1-4.6,0,5.88,5.88,0,0,1-1.87-1.2,5.45,5.45,0,0,1-1.26-1.78,5.35,5.35,0,0,1,0-4.34,5.45,5.45,0,0,1,1.26-1.78,5.88,5.88,0,0,1,1.87-1.2A6.07,6.07,0,0,1,173.29,367.22Zm0,2.54a3.22,3.22,0,0,0-2.28.89,3,3,0,0,0,0,4.3,3,3,0,0,0,1,.67,3.49,3.49,0,0,0,1.24.22,3.39,3.39,0,0,0,1.23-.22,3.14,3.14,0,0,0,1-.67,2.93,2.93,0,0,0,0-4.3A3.28,3.28,0,0,0,173.29,369.76Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.66,367.49v.85a6,6,0,0,0-1.49-.8,5.34,5.34,0,0,0-1.94-.32,5.81,5.81,0,0,0-2.27.43,5.42,5.42,0,0,0-1.79,1.2,5.56,5.56,0,0,0-1.19,1.78,5.82,5.82,0,0,0,0,4.34,5.56,5.56,0,0,0,1.19,1.78A5.42,5.42,0,0,0,139,378a5.81,5.81,0,0,0,2.27.43h.22a6.06,6.06,0,0,0,2.29-.43v-3h0a3.14,3.14,0,0,1-1,.67,3.39,3.39,0,0,1-1.23.22,4.38,4.38,0,0,1-.52,0h0a4.46,4.46,0,0,1-.72-.18,3,3,0,0,1-1-.67,3,3,0,0,1,0-4.3,3.41,3.41,0,0,1,1-.66,3.49,3.49,0,0,1,1.24-.23,3.18,3.18,0,0,1,2.27.89,2.84,2.84,0,0,1,.94,2.16v5.57h2.68V367.49Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.69,367.49v.85a5.94,5.94,0,0,0-1.5-.8,4.18,4.18,0,0,0-1-.25,6.88,6.88,0,0,0-1.15-.09,5.6,5.6,0,0,0-2.22.43,5.31,5.31,0,0,0-1.74,1.2,5.54,5.54,0,0,0-1.12,1.78,5.83,5.83,0,0,0-.4,2.18h0A5.62,5.62,0,0,0,123,375a5.44,5.44,0,0,0,3,3,5.76,5.76,0,0,0,2.26.43h.4a6,6,0,0,0,2.11-.42v-3h0a3.08,3.08,0,0,1-1.05.67,3.3,3.3,0,0,1-1.22.22,4.38,4.38,0,0,1-.52,0h0a4.21,4.21,0,0,1-.72-.18,2.86,2.86,0,0,1-1-.67,2.91,2.91,0,0,1-.94-2.15,3.25,3.25,0,0,1,.22-1.13.3.3,0,0,0,0-.08,3,3,0,0,1,.68-.94,3.29,3.29,0,0,1,1-.66,3.41,3.41,0,0,1,1.24-.23,3.18,3.18,0,0,1,2.27.89,3,3,0,0,1,.68.94s0,.05,0,.08a3,3,0,0,1,.22,1.14v4.24a2.88,2.88,0,0,1-.94,2.14,3.12,3.12,0,0,1-2.27.91,3,3,0,0,1-1.61-.43l-1.94,1.83a5.84,5.84,0,0,0,1.65.84,5.91,5.91,0,0,0,1.9.3,5.85,5.85,0,0,0,2.29-.45,5.93,5.93,0,0,0,1.88-1.2,5.76,5.76,0,0,0,1.26-1.78,5.29,5.29,0,0,0,.45-2.16v-9.56Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.16,387.59v.71H87.05v-4.05h3V385H87.85v1h1.84v.69H87.85v.91Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.3,383.92v4.33h-.81v-.19a1.81,1.81,0,0,1-.91.24,1.62,1.62,0,0,1,0-3.23,1.81,1.81,0,0,1,.91.24v-1.39Zm-.81,3.39v-1.25a1.14,1.14,0,0,0-.76-.27.89.89,0,0,0-.93.9.87.87,0,0,0,.93.89A1.14,1.14,0,0,0,94.49,387.31Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.4,385.14v3.12h-.8v-.21a1.49,1.49,0,0,1-.85.25c-.91,0-1.33-.42-1.33-1.43v-1.73h.8v1.73c0,.48.23.71.68.71a1.08,1.08,0,0,0,.7-.24v-2.2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.32,387.68a1.5,1.5,0,0,1-1.2.62,1.61,1.61,0,1,1,0-3.22,1.49,1.49,0,0,1,1.21.62l-.51.48a.86.86,0,0,0-.7-.38.89.89,0,1,0,0,1.78.84.84,0,0,0,.7-.38Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.44,385.14v3.12h-.79V388a1.66,1.66,0,0,1-.92.27,1.62,1.62,0,0,1,0-3.23,1.93,1.93,0,0,1,.92.26v-.19Zm-.79.93a1.2,1.2,0,0,0-.77-.27.89.89,0,1,0,0,1.78,1.18,1.18,0,0,0,.77-.26Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.58,385.8v1.1c0,.56.09.72.49.72a3.7,3.7,0,0,0,.37,0v.6a2.06,2.06,0,0,1-.72.11.9.9,0,0,1-1-1V385.8h-.44v-.66h.44v-1.22h.81v1.22h.87v.66Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.36,384.38a.47.47,0,0,1,.46-.47.46.46,0,0,1,.45.47.45.45,0,0,1-.45.46A.46.46,0,0,1,116.36,384.38Zm.06.8h.8v3.12h-.8Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.66,386.69a1.71,1.71,0,1,1-1.71-1.61A1.66,1.66,0,0,1,122.66,386.69Zm-.79,0a.9.9,0,0,0-.92-.89.89.89,0,1,0,0,1.78A.9.9,0,0,0,121.87,386.69Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.64,386.56v1.74h-.8v-1.74c0-.48-.23-.72-.68-.72a1.06,1.06,0,0,0-.69.25v2.21h-.8v-3.12h.8v.2a1.47,1.47,0,0,1,.84-.26C127.22,385.12,127.64,385.55,127.64,386.56Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.91,385v1.45h1.94v.71h-1.94v1.18h-.8v-4.05h3.06V385Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M141.33,386.69a1.71,1.71,0,1,1-1.71-1.61A1.66,1.66,0,0,1,141.33,386.69Zm-.79,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,140.54,386.69Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.29,385.14v3.12h-.8v-.21a1.52,1.52,0,0,1-.85.25c-.91,0-1.33-.42-1.33-1.43v-1.73h.79v1.73a.62.62,0,0,0,.68.71,1.09,1.09,0,0,0,.71-.24v-2.2Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.42,386.56v1.74h-.8v-1.74c0-.48-.24-.72-.68-.72a1.06,1.06,0,0,0-.69.25v2.21h-.8v-3.12h.8v.2a1.46,1.46,0,0,1,.83-.26C151,385.12,151.42,385.55,151.42,386.56Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.69,383.92v4.33h-.8v-.19a1.81,1.81,0,0,1-.91.24,1.62,1.62,0,0,1,0-3.23,1.81,1.81,0,0,1,.91.24v-1.39Zm-.8,3.39v-1.25a1.14,1.14,0,0,0-.76-.27.9.9,0,0,0-.94.9.88.88,0,0,0,.94.89A1.15,1.15,0,0,0,155.89,387.31Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162,385.14v3.12h-.8V388a1.6,1.6,0,0,1-.91.27,1.62,1.62,0,0,1,0-3.23,1.86,1.86,0,0,1,.91.26v-.19Zm-.8.93a1.16,1.16,0,0,0-.77-.27.89.89,0,1,0,0,1.78,1.14,1.14,0,0,0,.77-.26Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.12,385.8v1.1c0,.56.09.72.49.72a3.7,3.7,0,0,0,.37,0v.6a2.15,2.15,0,0,1-.73.11.89.89,0,0,1-.94-1V385.8h-.44v-.66h.44v-1.22h.81v1.22H166v.66Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.9,384.38a.47.47,0,0,1,.46-.47.46.46,0,0,1,.45.47.45.45,0,0,1-.45.46A.46.46,0,0,1,167.9,384.38Zm.06.8h.8v3.12H168Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.2,386.69a1.71,1.71,0,1,1-1.71-1.61A1.66,1.66,0,0,1,174.2,386.69Zm-.79,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,173.41,386.69Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.18,386.56v1.74h-.8v-1.74c0-.48-.24-.72-.68-.72a1.06,1.06,0,0,0-.69.25v2.21h-.8v-3.12h.8v.2a1.46,1.46,0,0,1,.83-.26C178.76,385.12,179.18,385.55,179.18,386.56Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 11.73,
    y1: 373.08,
    x2: 71.42,
    y2: 373.08
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6,375.86V371.4l-.86.91-.4-.4,1.34-1.38h.58v5.33Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 5.92,
    cy: 373.08,
    r: 5.67
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 11.73,
    y1: 192.48,
    x2: 71.42,
    y2: 192.48
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4,195.26v-.54c1.92-1.5,3-2.39,3-3.31a1,1,0,0,0-1.12-1,1.78,1.78,0,0,0-1.45.67L4,190.68a2.31,2.31,0,0,1,1.86-.84,1.62,1.62,0,0,1,1.79,1.57c0,1.09-1.1,2.08-2.59,3.26H7.65v.59Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 5.92,
    cy: 192.48,
    r: 5.67
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 50.2,
    y: 33.62,
    width: 368.5,
    height: 368.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.19,7.85l.39-.42a1.83,1.83,0,0,0,1.48.71c.78,0,1.25-.4,1.25-1s-.54-.95-1.33-.95h-.55V5.59H146c.68,0,1.24-.26,1.24-.88s-.54-.91-1.19-.91a1.81,1.81,0,0,0-1.41.65L144.26,4a2.29,2.29,0,0,1,1.83-.82c1,0,1.8.52,1.8,1.41a1.28,1.28,0,0,1-1.15,1.24A1.36,1.36,0,0,1,148,7.19c0,.89-.71,1.54-1.89,1.54A2.23,2.23,0,0,1,144.19,7.85Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 146.19,
    cy: 5.92,
    r: 5.67
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 146.18,
    y1: 39.14,
    x2: 146.18,
    y2: 11.63
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 87.05,
    y: 39.25,
    width: 110.57,
    height: 43.84
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 307.56,
    y1: 440.79,
    x2: 307.56,
    y2: 286.48
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.11,449.17v-1.35h-2.54v-.55l2.29-3.43h.91v3.4h.75v.58h-.75v1.35Zm0-4.72-1.87,2.79h1.87Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 307.56,
    cy: 446.46,
    r: 5.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvm3);
export default __webpack_public_path__ + "static/media/ivm3.2fd27bc82153adcb074bf87e45b4d9de.svg";
export { ForwardRef as ReactComponent };